// Human-readable messages for Google OAuth error codes returned by the
// backend as ?error=... on the /login or /register redirect.
export const GOOGLE_ERROR_MESSAGES = {
  google_not_configured:
    "Google Sign-In is not configured yet. Please continue with email or contact support.",
  google_denied: "Google sign-in was cancelled.",
  google_missing_params: "Google sign-in failed. Please try again.",
  google_bad_state: "This sign-in link has expired. Please try again.",
  google_exchange_failed: "We couldn't complete Google sign-in. Please try again.",
  google_no_token: "Google sign-in did not return a valid token. Please try again.",
  google_userinfo_failed: "We couldn't read your Google profile. Please try again.",
  google_no_email: "Your Google account does not expose an email address.",
  google_email_unverified: "Your Google email address is not verified.",
  google_network_error: "Network error while contacting Google. Please try again.",
  account_deactivated: "This account has been deactivated.",
};
